import { Li } from 'facades'
export default function Privacy() {
  return (
    <div>
      StyleMap 非常重視您的隱私權。因此不論您是剛開始使用 StyleMap，或是已使用一段時間，都請撥空瞭解我們的隱私權政策。如有任何疑問，歡迎透過客服信箱與我們聯絡 (客服Email: service@hairdodo.com 或私訊 <C.Link href={ h.path.stylist({ id: 1 }) } blank>StyleMap美配客服</C.Link>)。
      <Li level='1' number='1' text='我們收集的資訊' />
      { list[0] }
      <Li level='1' number='2' text='我們如何使用所收集的資訊' />
      <div { ...list[1].rawHtml() }/>
      <Li level='1' number='3' text='我們分享的資訊' />
      { list[2] }
      <Li level='1' number='4' text='資訊安全' />
      { list[3] }
      <Li level='1' number='5' text='行使個人資料權利方式' />
      <div { ...list[4].rawHtml() }/>
      <Li level='1' number='6' text='隱私權保護政策修訂' />
      <div { ...list[5].rawHtml() }/>
    </div>
  )
}

const List = ({ array, level }) => array.map((text, index) => (
  <Li key={ index } level={ level } number={ index + 1 } text={ text }/>
))

const list = [
  (
    <div key='0'>
      我們收集資訊是為了向所有使用者提供更優質的服務，我們收集資訊的方式有下列兩種:<br/>
      {
        <List level='2'
          array={
            [
              (
                <div key='0'>
                您所提供的資訊<br/>
                在您註冊 StyleMap 帳號、使用 StyleMap 服務時，StyleMap 會蒐集您的個人資料。在申請過程中，我們會請您提供個人資料。個人資料是指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址或電話號碼。
                </div>
              ),
              (
                <div key='1'>
                經由您對於我們服務的使用而取得的資訊<br/>
                  <List level='3'
                    array={
                      [
                        (
                          <div key='0'>
                        裝置資訊<br/>
                        我們會收集裝置專屬資訊，例如設備識別碼及相關硬體資訊等。
                          </div>
                        ),
                        (
                          <div key='1'>
                        記錄資訊<br/>
                        當您使用 StyleMap 服務或分享 StyleMap 提供的內容至您的 Facebook 頁面時，我們可能會自動收集特定資訊並儲存在伺服器記錄中。這類資訊可能包括：網際網路通訊協定位址。
                          </div>
                        )
                      ]
                    }
                  />
                </div>
              )
            ]
          }
        />
      }
    </div>
  ),
  `我們會將從我們服務收集到的資訊用於提供、維護與改善服務，以及保護 StyleMap 和我們的使用者。我們也會運用這些資訊，針對您的需求提供個人化的服務內容。

在將資訊用於本隱私權政策未載明的用途時，我們會先詢問您是否同意。`,
  (
    <div key='2'>
      除非以下任何一種情況，否則我們不會向 StyleMap 以外的任何其他公司、機構或個人分享您的個人資料：<br/>
      <List level='2'
        array={
          [
            '事先徵得您的認可。分享任何敏感的個人資訊之前，我們都會先徵求您的認可。',
            '對於個別服務提供者之資訊提供。會員對於服務提供者之商品或服務進行預訂、購買、參加贈獎活動或申請其他交易時，StyleMap 於該交易所必要之範圍內，得將會員之個人資料檔案提供予服務提供者，並由服務提供者負責管理該個人資料檔案。StyleMap 將以規約課予服務提供者依保障會員隱私權之原則處理個人資料之義務，但無法保證服務提供者會必然遵守。詳細內容，請向個別服務提供者洽詢。',
            '我們會將個人資訊提供給我們的關係企業或其他可信賴的公司或人員，請他們根據我們的指示，並遵守本隱私權政策和任何其他適當的保密和安全措施，代為處理這類資訊。',
            '對傳票、法院命令、法律程序或政府執行命令作出回應、取得或行使法律權利。為了協助調查和防止非法活動、涉嫌詐欺、對人身安全有潛在威脅的狀況、對 StyleMap 服務條款的違反，或為了對上述情形採納相關應對措施，或法律另有其規定，而有必要分享您的個人資料時。',
            '如果 StyleMap 被其他公司收購或合併，我們將繼續嚴守任何個人資訊之保密，並且會在您的個人資料被移轉且將適用不同的隱私權政策前通知您。'
          ]
        }
      />
      除此，我們會與大眾或合作夥伴如出版商、廣告客戶或贊助商等，分享無法識別身分的統整資訊。舉例而言，我們會將統整資訊對外公開，讓外界瞭解 StyleMap 服務的一般使用情形。
    </div>
  ),
  (
    <div key='3'>
      我們致力於保護所持有的 StyleMap 和使用者相關資訊，防止未經授權而遭到存取、竄改、揭露或毀損。尤其是：<br/>
      <List level='2'
        array={
          [
            '我們使用SSL為我們的服務加密。',
            '我們提供多步驟的驗證機制供您存取 StyleMap 服務。',
            '我們僅允許為了代表我們處理個人資訊而需知悉該等資訊的 StyleMap 員工來存取資訊。並且相關人員均須遵守嚴格的契約保密義務，一旦未遵守義務便將受到懲戒或解約處分。'
          ]
        }
      />

    </div>
  ),
  '依個人資料保護法規定，您就您的個人資料享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除之權利。您可以Email聯繫我們 service@hairdodo.com（為避免電子郵件系統漏信或其他原因無法收悉，以本公司回覆收悉為準），本公司將於收悉您的請求後，儘速處理。',
  'StyleMap 會不時變更修訂。當我們在個人資料的處理上有重大變更時，會將通知傳送到您在 StyleMap 帳號中指定的主要電子郵件地址，或在我們的網站上張貼告示，方便您查閱。'
]
